module.exports = __webpack_public_path__ + "img/icon_docs.b763e450.svg";